import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { safeRemoveItem, safeSetItem } from "@mediatechgroup/app-version";

// Type definitions
interface SettingsData {
  business_name?: string;
  [key: string]: unknown;
}

export interface SettingsState {
  data: SettingsData | null;
  clubName: string | null;
}

const initialState: SettingsState = {
  data: null,
  clubName: null,
};

const settingsSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setSettings: (state, action) => {
      state.data = action.payload;
      state.clubName = action.payload?.business_name || null;

      // ✅ also persist to localStorage
      safeSetItem("settings", JSON.stringify(action.payload));
      if (action.payload?.business_name) {
        safeSetItem("clubName", action.payload.business_name);
      }
    },
    clearSettings: (state) => {
      state.data = null;
      state.clubName = null;
      safeRemoveItem("settings");
      safeRemoveItem("clubName");
    },
  },
});

export const { setSettings, clearSettings } = settingsSlice.actions;

// ✅ selectors
export const selectSettings = (state: RootState) => state.setting.data;
export const selectClubName = (state: RootState) => state.setting.clubName;

export default settingsSlice.reducer;
